import React from 'react';
import PropTypes from 'prop-types';
import Auth from '@Services/Auth';
import RxStructureService from '@Services/RxStructureService';
import { getValueByNs } from '@Hooks/LibraryInitialization/MoreUnderscore';
import { ButtonWithIcon } from '@els/els-react--button';
import find from 'lodash/find';
import { FEATURES } from '@Constants/rx-ui/constants';

export default class CommercialSubstancesProviderComponent extends React.Component {
  openInDatabase(db) {
    const { closeMenu } = this.props;
    RxStructureService.openInDatabase(db, getValueByNs(this.context, 'metadata.originalSearchType'));
    // eslint-disable-next-line no-unused-expressions
    closeMenu && closeMenu();
  }

  render() {
    const { structure, onClick } = this.props;
    const commercialSubstances = find(getValueByNs(this, 'props.structure.subLinks', []), { databaseId: '20' });
    return commercialSubstances ? (
      <tr role="menuitem">
        <td className="column-provider-logo shopping-cart-block">
          {Auth.isFeatureEnabled(FEATURES.enableDisplaySupplierNumber) && !!structure.supplierNumber && (
            <span className="shopping-cart-icon-number">{structure.supplierNumber}</span>
          )}
          <svg className="icon-shopping-cart">
            <use xlinkHref="#icon-shopping-cart" />
          </svg>
        </td>
        <td>
          <ButtonWithIcon
            className="provider-link e2e-shopping-cart-commercial-substances"
            sprite="ChevronRight"
            iconRight
            type="link"
            linkIconSize="xs"
            onClick={() => {
              onClick();
              this.openInDatabase(commercialSubstances);
            }}>
            Commercial Suppliers
          </ButtonWithIcon>
        </td>
      </tr>
    ) : null;
  }
}

CommercialSubstancesProviderComponent.defaultProps = {
  onClick: () => null,
};

CommercialSubstancesProviderComponent.propTypes = {
  structure: PropTypes.object.isRequired,
  closeMenu: PropTypes.func.isRequired,
  onClick: PropTypes.func,
};
